export enum CreditCheckType {
  SOFT = 'Soft',
  HARD = 'Hard',
  HARD_MANUAL = 'Hard manual',
  SOFT_MANUAL = 'Soft manual',
}

export interface CreditCheckResult {
  type: CreditCheckType | 'UNKNOWN';
  referenceNumber: string;
  creditScore: number;
  dateOfSearch: string;
}

export enum CreditField {
  ReferenceNumber = 'referenceNumber',
  CreditScore = 'creditScore',
  DateOfSearch = 'dateOfSearch',
}
